(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slide"] && !Shopify.designMode) return;
  try {
    
(function() {
  let currentIndex = 0;
  const slides = document.querySelectorAll('#two-image-slider .slide');
  const slideCount = slides.length;
  const prevButton = document.querySelector('#two-image-slider .prev-arrow');
  const nextButton = document.querySelector('#two-image-slider .next-arrow');
  let slideInterval;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slideCount;
    showSlide(currentIndex);
  }

  function prevSlide() {
    currentIndex = (currentIndex - 1 + slideCount) % slideCount;
    showSlide(currentIndex);
  }

  // Auto slide every 5 seconds
  function startAutoSlide() {
    slideInterval = setInterval(nextSlide, 5000);
  }

  function stopAutoSlide() {
    clearInterval(slideInterval);
  }

  // Initialize
  showSlide(currentIndex);
  startAutoSlide();

  // Event listeners for arrows
  prevButton.addEventListener('click', function() {
    prevSlide();
    stopAutoSlide();
    startAutoSlide();
  });

  nextButton.addEventListener('click', function() {
    nextSlide();
    stopAutoSlide();
    startAutoSlide();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-collection-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const mainCollections = document.querySelectorAll('.main-collection');
  const subCollectionGroups = document.querySelectorAll('.sub-collection-group');

  function showSubCollections(index) {
    subCollectionGroups.forEach(group => {
      group.style.display = (group.dataset.collectionIndex == index) ? 'flex' : 'none';
    });

    mainCollections.forEach(collection => {
      collection.classList.remove('active');
    });

    const activeCollection = document.querySelector(`.main-collection[data-collection-index="${index}"]`);
    if (activeCollection) {
      activeCollection.classList.add('active');
    }

    const activeGroup = document.querySelector(`.sub-collection-group[data-collection-index="${index}"]`);
    if (activeGroup) {
      initializePagination(activeGroup);
    }
  }

  function initializePagination(group) {
    const dots = group.parentElement.querySelectorAll('.dot');
    const subCollections = group.querySelectorAll('.sub-collection');

    dots.forEach(dot => dot.classList.remove('active'));
    if (dots[0]) {
      dots[0].classList.add('active');
    }

    group.addEventListener('scroll', () => {
      const scrollLeft = group.scrollLeft;
      const width = group.clientWidth;
      const scrollWidth = group.scrollWidth;
      const index = Math.round((scrollLeft / (scrollWidth - width)) * (dots.length - 1));

      dots.forEach(dot => dot.classList.remove('active'));
      if (dots[index]) {
        dots[index].classList.add('active');
      }
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const cardWidth = subCollections[0].clientWidth;
        group.scrollTo({
          left: index * (cardWidth + 10), // Adjust margin as needed
          behavior: 'smooth'
        });
      });
    });
  }

  showSubCollections(1);

  mainCollections.forEach((mainCollection, index) => {
    mainCollection.addEventListener('click', () => {
      showSubCollections(index + 1);
    });
  });

  // Function to add product to cart
  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(data => { throw new Error(data.description); });
      }
      return response.json();
    })
    .then(data => {
      console.log('Product added to cart:', data);
      // Open the cart drawer once after product is added
      if (typeof Shopify !== 'undefined' && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.openCartDrawer();
      } else {
        window.location.href = '/cart'; // Fallback if drawer is unavailable
      }
      // Update cart count manually
      updateCartCount();
    })
    .catch(error => {
      console.error('Error adding product to cart:', error.message);
      alert('There was an issue adding this product to the cart. Please try again.');
    });
  }

  // Function to update the cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = cart.item_count;
        const cartCountElement = document.querySelector('.cart-count');
        if (cartCountElement) {
          cartCountElement.textContent = cartCount;
        }
      })
      .catch(error => console.error('Error updating cart count:', error.message));
  }

  // Event listener for the Add to Cart buttons
  const addToCartButtons = document.querySelectorAll('.add-to-cart');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const variantId = this.getAttribute('data-product-id');
      if (variantId) {
        addToCart(variantId);
      } else {
        console.error('Variant ID not found.');
      }
    });
  });

  // Initial cart count update when the page loads
  updateCartCount();
// end drawer cart

  // function showToastNotification(message) {
  //   const toast = document.createElement('div');
  //   toast.className = 'toast-notification';
  //   toast.innerText = message;

  //   document.body.appendChild(toast);

  //   setTimeout(() => {
  //     document.body.removeChild(toast);
  //   }, 3000);
  // }

  // // Overlay logic for mobile screens
  // function openOverlay(productId) {
  //   const overlay = document.createElement('div');
  //   overlay.className = 'overlay';
    
  //   const overlayContent = `
  //     <div class="overlay-content">
  //       <h2>Product Details</h2>
  //       <p>Product ID: ${productId}</p>
  //       <button class="close-overlay">Close</button>
  //     </div>
  //   `;

  //   overlay.innerHTML = overlayContent;
  //   document.body.appendChild(overlay);

  //   document.querySelector('.close-overlay').addEventListener('click', function() {
  //     document.body.removeChild(overlay);
  //   });
  // }

  // CSS for the overlay
  const style = document.createElement('style');
  style.innerHTML = `
    .overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
    }

    .overlay-content {
      background: white;
      padding: 20px;
      border-radius: 5px;
      text-align: center;
    }

    .close-overlay {
      margin-top: 20px;
      background: red;
      color: white;
      padding: 10px 20px;
      border: none;
      cursor: pointer;
    }
  `;
  document.head.appendChild(style);
});

  } catch(e) { console.error(e); }
})();
})();
